declare var ng;

export interface IElementSearchOptions {
    //stopTagName?: string;
    stopTagNames?: string[];

    currentSearchDepth?: number;
    maxDepth?: number;
}

export class HTMLService {
    scrollTo(elementId: string, offsetY = 0, iterationCount = 50) {

        if (!elementId) {
            console.error("No elementId passed in");
            return;
        }

        var targetElement = document.getElementById(elementId);

        if (targetElement == null) {
            if (iterationCount >= 0) {
                setTimeout(() => {
                    this.scrollTo(elementId, offsetY, --iterationCount);
                }, 150);
            }

            return;
        }

        //targetElement.scrollIntoView({ behavior: "auto", block: "center" });
        targetElement.scrollIntoView({ behavior: "auto", block: "center" });
    }

    //isElementInView(targetElement: HTMLElement, scrollParent: HTMLElement): boolean {
    //    if (!targetElement || !scrollParent) {
    //        return false;
    //    }

    //    var boundingRect = targetElement.getBoundingClientRect();
    //    var parentBoundingRect = scrollParent.getBoundingClientRect();

    //    console.log(boundingRect, parentBoundingRect);

    //    console.log(boundingRect.top >= 0, boundingRect.bottom <= scrollParent.clientHeight);
    //    console.log(boundingRect.top, boundingRect.bottom, scrollParent.clientHeight, scrollParent.scrollTop, scrollParent.scrollHeight);
    //    console.log("A TING", this.visibleInScroll(targetElement, scrollParent));

    //    return (
    //        boundingRect.top >= 0 &&
    //        //boundingRect.left >= 0 &&
    //        boundingRect.bottom <= scrollParent.clientHeight /*&&*/
    //        //boundingRect.right <= scrollParent.clientWidth
    //    );

    //    return true;
    //}

    private visibleInScroll(element: HTMLElement, parent: HTMLElement): boolean {
        if (!element || !parent) {
            return false;
        }

        var elRect = element.getBoundingClientRect() as any,
            rects = [parent.getBoundingClientRect()];

        elRect = {
            left: elRect.left,
            top: elRect.top,
            right: elRect.right,
            bottom: elRect.bottom,
            width: elRect.width,
            height: elRect.height,
            visibleWidth: elRect.width,
            visibleHeight: elRect.height,
            isVisible: true,
            isContained: true
        };

        //var elWidth = elRect.width,
        //    elHeight = elRect.height;

        //if (parent === this[0].ownerDocument) {
        //    return true;
        //    return elRect;
        //}

        //var goDeep = false;

        //while (parent !== this[0].ownerDocument && parent !== null) {
        //    if (parent.scrollWidth > parent.clientWidth || parent.scrollHeight > parent.clientHeight) {
        //        rects.push(parent.getBoundingClientRect());
        //    }

        //    if (rects.length && goDeep) {
        //        break;
        //    }

        //    parent = $(parent).scrollParent()[0];
        //}
        //if (!goDeep) {
        //    rects.length = 1;
        //}

        for (var i = 0; i < rects.length; i += 1) {
            var rect = rects[i];
            elRect.left = Math.max(elRect.left, rect.left);
            elRect.top = Math.max(elRect.top, rect.top);
            elRect.right = Math.min(elRect.right, rect.right);
            elRect.bottom = Math.min(elRect.bottom, rect.bottom);
        }

        elRect.visibleWidth = Math.max(0, elRect.right - elRect.left);
        elRect.visibleHeight = elRect.visibleWidth && Math.max(0, elRect.bottom - elRect.top);

        if (!elRect.visibleHeight) {
            elRect.visibleWidth = 0;
        }

        elRect.isVisible = elRect.visibleWidth > 0 && elRect.visibleHeight > 0;
        elRect.isContained = elRect.visibleWidth === elRect.width && elRect.visibleHeight === elRect.height;

        return elRect.isContained;
    };


    scrollStep(scrollingParent: HTMLElement, stopY: number, step: number, speed: number) {
        //throw new Error("Method not implemented.");
        setTimeout(() => {
            var iterate = true;
            var newPosition = scrollingParent.scrollTop + step;

            if (step < 0 && stopY >= newPosition || step > 0 && stopY <= newPosition) {
                newPosition = stopY;
                iterate = false;
            }

            scrollingParent.scrollTop = scrollingParent.scrollTop + step;
            console.log("newPos", newPosition, "scrollTop", scrollingParent.scrollTop, "stopY", stopY, "step", step);

            if (iterate) {
                this.scrollStep(scrollingParent, stopY, step, speed);
            }
        }, speed);
    }

    getAngularParentByTag<T>(element: HTMLElement, tagName: string): T {
        var element = this.getParentByTag(element, tagName);

        return this.getAngularComponentFromElement<T>(element);
    }

    getAngularComponentFromElement<T>(element: HTMLElement): T {
        console.warn("Warning, getAngularComponentFromElement wont work in production");

        var ngProbeElement = ng.probe(element);

        return ngProbeElement?.componentInstance;
    }

    getAngularJSComponentFromElement<T>(element: HTMLElement): T {
        var ngElement = window.angular.element(element);
        var scope: any = (ngElement.isolateScope() || ngElement.scope());

        return scope?.$ctrl;
    }

    getParentByTag(startElement: HTMLElement, tagName: string, className?: string, options?: IElementSearchOptions): HTMLElement {

        if (!startElement) {
            return null;
        }

        var parent: HTMLElement = startElement;

        while (parent.parentElement) {
            parent = parent.parentElement;

            if (options?.stopTagNames?.indexOf(parent.tagName.toLocaleLowerCase()) >= 0) {
                return;
            }

            if (parent.tagName.toLocaleLowerCase() == tagName) {
                if (!className || parent.className.indexOf(className) >= 0) {
                    return parent;
                }
            }
        }

        return null;
    }

    findNearest(startingElement: HTMLElement, selector: string, ignoreParents = false, options?: IElementSearchOptions): HTMLElement {

        if (options) {

            if (!options.currentSearchDepth) {
                options.currentSearchDepth = 0;
            }

            if (options.maxDepth && options.currentSearchDepth >= options.maxDepth) {
                return null;
            }

            options.currentSearchDepth = options.currentSearchDepth + 1;
        }

        for (var i = 0; i < startingElement.children.length; i++) {
            var childElement = startingElement.children[i] as HTMLElement;

            if (options?.stopTagNames?.indexOf(childElement.tagName.toLocaleLowerCase()) >= 0) {
                return;
            }

            if (selector[0] == '.' && childElement.classList.contains(selector.substring(1))) {
                return childElement;
            }
            else if (childElement.tagName.toLocaleLowerCase() == selector) {
                return childElement;
            }

            const childResult = this.findNearest(childElement, selector, true, options);
            if (childResult) {
                return childResult;
            }
        }

        if (!ignoreParents && startingElement.parentElement && startingElement.tagName.toLocaleLowerCase() != "default-layout") {
            return this.findNearest(startingElement.parentElement, selector, null, options);
        }

        return null;
    }

    getElementScrollRect(element: HTMLElement, parentTag?: string): ClientRect {
        // Get veriCard parent
        if (element) {
            //var veriCardParent: HTMLElement = this.getParentByTag(targetElement, "video-entry");
            //var veriTabElement: HTMLElement = this.getParentByTag(targetElement, "veri-tab");
            //var veriList: HTMLElement = this.getParentByTag(targetElement, "div", "video-list");

            //var finalWidth = element.offsetWidth;
            //var finalHeight = element.offsetHeight;

            // 44 is the tab height that disappears... 
            //var tabHeight = this.isMobile ? 0 : 44;

            var scrollParent = this.getScrollParent(element);

            return {
                left:/* veriCardParent.offsetLeft +*/ element.offsetLeft,
                top: /*veriCardParent.offsetTop +*/ element.offsetTop - scrollParent.scrollTop /*+ tabHeight*/,
                right: 0,
                bottom: 0,
                width: element.offsetWidth,
                height: element.offsetHeight
            }
        }
        else {
            return {
                left: 0,
                top: /*tabHeight*/0,
                right: 0,
                bottom: 0,
                width: "100%" as any,
                height: "100%" as any
            }
        }
    }

    getScrollParent(element: HTMLElement, includeHidden = false): HTMLElement {
        if (!element) {
            return null;
        }

        var style = getComputedStyle(element);
        var excludeStaticParent = style.position === "absolute";
        var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

        if (style.position === "fixed") {
            return document.body;
        }

        for (var parent = element; (parent = parent.parentElement);) {
            style = getComputedStyle(parent);

            if (excludeStaticParent && style.position === "static") {
                continue;
            }

            if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) {
                return parent;
            }
        }

        return document.scrollingElement as HTMLElement || document.body;
    }

    // ---


}
